import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { TimeBalanceDetailsPopover } from './TimeBalanceDetailsPopover';
import styled from '@emotion/styled';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { DifferenceWithSign } from '../DifferenceWithSign';
import { WithdrawTimeBalanceModal } from './WithdrawTimeBalance/WithdrawTimeBalanceModal';

export type SelfWithdrawalConfig = {
  enabled: boolean;
  allowMonetary: boolean;
  allowCompensatory: boolean;
};

type Props = {
  timeBalance: number | null;
  selfWithdrawal: SelfWithdrawalConfig;
};

// packages/web/src/apps/dashboard/manager/TimeSheetsControlling/TopPanel/TimeSheetTopPanel.tsx
export const TimeBalancePanel: React.FC<React.PropsWithChildren<Props>> = ({
  timeBalance,
  selfWithdrawal,
}) => {
  const t = useNamespacedTranslation('components.timeBalancePanel');
  const [showWithdraw, setShowWithdraw] = useState(false);
  const withdrawalEnabled =
    selfWithdrawal.enabled &&
    (selfWithdrawal.allowMonetary || selfWithdrawal.allowCompensatory);
  const canWithdraw =
    timeBalance !== null && timeBalance > 0 && withdrawalEnabled;

  return (
    <Card className="px-3">
      <div className="d-flex align-items-center justify-content-between py-3 mx-3 gap-3">
        <TextContainer className="d-none d-sm-flex align-items-center h5-regular color-gray-2">
          {t('text')}
        </TextContainer>
        <div className="d-flex align-items-center gap-4">
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-between">
              <div className="h6-regular color-paper-1 me-2">
                {t('current')}
              </div>
              <TimeBalanceDetailsPopover />
            </div>
            <TimeBalanceContainer
              className="h1-medium text-nowrap"
              data-testid="current-time-balance">
              {timeBalance !== null ? (
                <DifferenceWithSign value={timeBalance} withColor={true} />
              ) : (
                <div className="text-success">-</div>
              )}
            </TimeBalanceContainer>
          </div>
          {canWithdraw && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowWithdraw(true)}
              data-testid="withdraw-time-balance-button">
              {t('withdraw.action')}
            </Button>
          )}
        </div>
      </div>
      {canWithdraw && (
        <WithdrawTimeBalanceModal
          show={showWithdraw}
          onClose={() => setShowWithdraw(false)}
          availableMinutes={timeBalance}
          allowMonetary={selfWithdrawal.allowMonetary}
          allowCompensatory={selfWithdrawal.allowCompensatory}
        />
      )}
    </Card>
  );
};

const TextContainer = styled.div({
  maxWidth: '50rem',
});

const TimeBalanceContainer = styled.div({
  maxWidth: '50rem',
});
